export default __webpack_public_path__ + "static/media/abhishek.6456737c.jpeg";